import * as actions from "./../catalogActions";

export default function getData(_) {
  return (dispatch) => {
    return new Promise((resolve, _) => {
      const returnedResponses = [];
      const fakeDispatch = (objToDispatch) => {
        dispatch(objToDispatch);
        returnedResponses.push(objToDispatch);
        if (returnedResponses.length >= 3) {
          resolve();
        }
      };

      Promise.all([
        actions.getPopularSizes()(fakeDispatch),
        actions.getTopSellers()(fakeDispatch),
        actions.getHomepagePromo()(fakeDispatch),
      ]);
    });
  };
}
